import { faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react'
import { useParams } from 'react-router'

import { type OnboardingPage } from '../routes'
import { PricingRCPCoversSection } from '../components/PricingRCPCoversSection'
import { PricingRCPOptionsSection } from '../components/PricingRCPOptionsSection'
import { OnboardingTitle } from '../components/OnboardingTitle'
import { OnboardingNextButton } from '../components/OnboardingNextButton'
import { useOnboardingWorkflow } from '../workflow'
import { PricingRCPGuaranteeAmountSlider } from '../components/PricingRCPGuaranteeAmountSlider'
import { PricingRCPCoverOptions } from '../components/PricingRCPCoverOptions'
import { PricingCard } from '../components/PricingCard'
import { FormattedPrice } from '../components/FormattedPrice'
import { track } from '../../utils/analytics'
import { useQuotation } from '../context'

import { Card, CardContent } from '@olino/design-system'

const Main = () => {
  const { id } = useParams()
  const { proceed } = useOnboardingWorkflow()
  const { quotation } = useQuotation()

  const onProceed = () => {
    track({
      event: 'submitted_pricing_page',
      quotation_id: id,
    })

    proceed()
  }

  useEffect(() => {
    track({
      event: 'visited_pricing_page',
      quotation_id: id,
    })
  }, [id])

  return (
    <>
      <OnboardingTitle.H1>
        Votre devis pour votre responsabilité&nbsp;civile professionnelle
      </OnboardingTitle.H1>

      <div className="space-y-14">
        <div className="block lg:hidden">
          <PricingCard>
            <PricingRCPCoversSection />
          </PricingCard>
        </div>

        <Card>
          <CardContent className="space-y-8">
            <div className="flex flex-col justify-between gap-3 md:flex-row">
              <div>
                <OnboardingTitle.H2Pricing>Protections essentielles</OnboardingTitle.H2Pricing>
                <span className="text-xs md:text-sm">
                  Ce sont les protections minimales dont vous ne pouvez vous passer.
                </span>
              </div>

              <div className="space-y-3">
                <FormattedPrice
                  size="sm"
                  originalAmount={quotation.premium?.publicLiability?.base}
                  hideLoader
                />
              </div>
            </div>

            <PricingRCPGuaranteeAmountSlider />

            <div className="space-y-3">
              <p>
                Nous incluons 7 garanties essentielles pour protéger au mieux votre entreprise :
              </p>
              <PricingRCPCoverOptions displayOnlyCover />
            </div>
          </CardContent>
        </Card>

        <div className="flex flex-col gap-8">
          <PricingRCPOptionsSection />

          <div className="flex justify-end">
            <OnboardingNextButton onClick={() => onProceed()}>
              Souscrire
              <FontAwesomeIcon icon={faArrowRight} />
            </OnboardingNextButton>
          </div>
        </div>
      </div>
    </>
  )
}

const Tips = () => {
  return (
    <div className="hidden lg:block">
      <PricingCard showQuote={true} showEntreeRel={false}>
        <PricingRCPCoversSection />
      </PricingCard>
    </div>
  )
}

export default {
  main: <Main />,
  tips: <Tips />,
} satisfies OnboardingPage
